export const appConfig = {
  REACT_APP_WEB_API_BASE_URI: "/api",

  SSO: "keycloak",

  keycloak: {
    REACT_APP_KEYCLOAK_URL: "/auth",
    REACT_APP_KEYCLOAK_REALM: "myrealm",
    REACT_APP_KEYCLOAK_CLIENT_ID: "frontend",
    REACT_APP_KEYCLOAK_LOGIN_REDIRECT_URI: window.location.origin + "/",
    REACT_APP_KEYCLOAK_LOGOUT_REDIRECT_URI: window.location.origin + "/",
  },

  azure: {
    REACT_APP_MSAL_CLIENT_ID: "",
    REACT_APP_WEB_API_BASE_URI: "/api",
    REACT_APP_MSAL_CLIENT_SCOPE: "",
    REACT_APP_MSAL_TENANT_AUTHORITY_URI: "",
    REACT_APP_MSAL_CACHE_LOCATION: "sessionStorage",
    REACT_APP_MSAL_AUTH_STATE_IN_COOKIE: "false",
    REACT_APP_MSAL_LOGIN_REDIRECT_URI: window.location.origin + "/",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: window.location.origin + "/",
  },
};
